<template>
    <v-dialog
        v-model="dialog"
        width="800"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="green"
                v-bind="attrs"
                v-on="on"
                icon
            >
                <v-icon>mdi-file-upload</v-icon>
            </v-btn>
        </template>

        <v-card>
            <v-card-title class="primary">
                Upload Files
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-card
                                @drop.prevent="onDrop"
                                @dragover.prevent="dragover = true"
                                @dragenter.prevent="dragover = true"
                                @dragleave.prevent="dragover = false"
                                @click.prevent.stop="handleFileImport"
                                :loading="isSelecting"
                            >
                                <v-card-text>
                                    <v-row class="d-flex flex-column" dense align="center" justify="center">
                                        <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                                            mdi-cloud-upload
                                        </v-icon>
                                        <p>
                                            Drop your file(s) here, or click to select them.
                                        </p>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                            cols="4"
                            class="d-flex align-center"
                        >
                            <input
                                ref="uploader"
                                class="d-none"
                                type="file"
                                multiple
                                @change="onFileChanged"
                            >
                            <v-btn
                                v-if="showUploadAll"
                                @click="uploadAll"
                                color="primary"
                                rounded
                                dark
                            >Upload All</v-btn>
                        </v-col>
                        <v-col
                            cols="8"
                            class="d-flex align-center"
                        >
                            <v-progress-linear
                                v-if="uploads.length"
                                height="25"
                                striped
                                rounded
                                :indeterminate="uploadingFiles"
                                class="progress-bar"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
                <file-display
                    v-for="(file, index) in uploads"
                    :input="file"
                    :fileIndex="index"
                    :key="index"
                    :minSize="10240"
                    :maxSize="4194304"
                    :validTypes="['application/pdf','image/jpeg','image/png']"
                    v-on:remove-file="removeFile"
                    v-on:update-progress="updateProgress"
                ></file-display>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="closeModal"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import FileDisplay from "@/Pages/FileUpload/FileDisplay";

export default {
    name: "FileUploadModal",
    components: {
        FileDisplay,
    },
    props: {
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            uploads: [],
            uploadsProgress:[],
            progress: 0,
            isSelecting: false,
            showUploadAll: false,
            dialog: false,
            dragover: false,
        }
    },
    methods: {
        handleFileImport() {
            this.isSelecting = true;

            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });

            // Trigger click on the FileInput
            this.$refs.uploader.click();
        },
        onFileChanged(e) {
            for (let i = 0; i < e.target.files.length; i++) {
                this.uploads.push({file: e.target.files[i], uploading:false, uploaded: false})
            }
            this.progress=0
            this.showUploadAll=true
            this.$refs.uploader.value=null
        },
        removeFile(fileIndex) {
            this.uploads.splice(fileIndex,1)
            if(this.uploads.length===0)
                this.showUploadAll=false
        },
        updateProgress({fileIndex, loadedSize, totalSize}) {
            this.uploadsProgress[parseInt(fileIndex)] = {loaded: parseInt(loadedSize), total: parseInt(totalSize)};
            this.progress = this.calculateProgress();
        },
        calculateProgress() {
            let loaded = 0;
            let total = 0;
            let progress = 0;

            for(let i=0; i<this.uploadsProgress.length; i++) {
                loaded += this.uploadsProgress[i].loaded
                total += this.uploadsProgress[i].total
            }

            if (total > 0) {
                progress = Math.round((loaded * 100) / total)
            }
            if (progress==100)
                this.showUploadAll=false
            return progress
        },
        uploadAll() {
            this.uploads.map(upload=>{
                if(!upload.uploaded && !upload.uploading) {
                    upload.uploading = true;
                }
            })
        },
        closeModal() {
            this.dialog = false
            this.$emit('closed');
            this.uploads=[]
        },
        onDrop(e) {
            this.dragover = false;
            if (!this.multiple && e.dataTransfer.files.length > 1) {
                this.$page.snackbar.error('Only one file can be uploaded at a time..')
            } else {
                for (let i = 0; i < e.dataTransfer.files.length; i++) {
                    this.uploads.push(e.dataTransfer.files.item(i));
                }
                this.showUploadAll=true
            }
        }
    },
    watch: {
        uploads: function() {
            let diff = this.uploads.length - this.uploadsProgress
            if(diff > 0) {
                for(let i=0; i<diff; i++) {
                    this.uploadsProgress.push({'loaded': 0, 'total': 0})
                }
            }
        },
    },
    computed: {
        uploadingFiles() {
            return this.uploads.some(function(upload) {return upload.uploading})
        }
    }
}
</script>

<style scoped>

</style>
